/* Plantica — Active formula: the rest of the ingredients behind a button
   (sections/plantica-formula.liquid).

   Below 990px the ingredients are one long column, so only the first few show
   and „Vezi toate ingredientele" opens the rest. The collapse is put on by this
   script, not by the stylesheet: a browser that never runs it shows every
   ingredient and no button.

   Custom file. See CUSTOMIZATIONS.md. */

(() => {
  if (customElements.get('plantica-formula-more')) return;

  class PlanticaFormulaMore extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('button');
      this.grid = button && document.getElementById(button.getAttribute('aria-controls'));
      if (!this.grid) return;

      const visible = Number(this.dataset.visible) || 5;
      Array.from(this.grid.children).forEach((item, index) => {
        item.classList.toggle('is-extra', index >= visible);
      });
      this.grid.classList.add('is-collapsed');
      this.hidden = false;
      button.addEventListener('click', this.expand);
    }

    expand = () => {
      this.grid.classList.remove('is-collapsed');
      this.querySelector('button').setAttribute('aria-expanded', 'true');
      this.hidden = true;

      // The button is gone: the keyboard goes to the first ingredient it showed.
      const first = this.grid.querySelector('.is-extra');
      if (first) {
        first.setAttribute('tabindex', '-1');
        first.focus({ preventScroll: true });
      }
    };
  }

  customElements.define('plantica-formula-more', PlanticaFormulaMore);
})();
